import { render, staticRenderFns } from "./WebPartFormDesignerToolbar.vue?vue&type=template&id=d64094c8&scoped=true&"
import script from "./WebPartFormDesignerToolbar.vue?vue&type=script&lang=js&"
export * from "./WebPartFormDesignerToolbar.vue?vue&type=script&lang=js&"
import style0 from "./WebPartFormDesignerToolbar.vue?vue&type=style&index=0&id=d64094c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64094c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d64094c8')) {
      api.createRecord('d64094c8', component.options)
    } else {
      api.reload('d64094c8', component.options)
    }
    module.hot.accept("./WebPartFormDesignerToolbar.vue?vue&type=template&id=d64094c8&scoped=true&", function () {
      api.rerender('d64094c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartFormDesignerToolbar.vue"
export default component.exports